import { CheckoutDataFragment } from "../../../../api/backend/backend-api"

import { AppThunk } from "../../../../state/store"
import { saveBasket } from "../../services/persist"
import {
  updateBasketCompleted,
  updateBasketError,
  updateBasketStarted,
} from "../checkoutSlice"
import { Basket } from "../checkoutTypes"
import { toBasket } from "../converters/toBasket"

export interface BasketOperation {
  operation: (
    basket: Basket,
    languageId: string
  ) => Promise<CheckoutDataFragment | undefined>
  callback?: () => void
  errorCallback?: (error: any) => void
}

export const basketChange = (data: BasketOperation): AppThunk => async (
  dispatch,
  getState
) => {
  const { operation, callback, errorCallback } = data
  const languageId = getState().localization.languageId
  dispatch(updateBasketStarted())

  try {
    const currentBasket = getState().checkout.basket
    if (!currentBasket) {
      throw new Error("Missing basket")
    }

    const checkout = await operation(currentBasket, languageId)
    if (!checkout) {
      return
    }

    const basket = toBasket(checkout)
    saveBasket(basket)
    dispatch(updateBasketCompleted(basket))

    callback?.()
  } catch (err) {
    dispatch(updateBasketError(err.toString()))
    errorCallback?.(err)
    console.error("Error updating basket", err)
  }
}
